module.exports = __webpack_public_path__ + "static/img/ershi.423c22e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imges/ershi.png
// module id = Zt0F
// module chunks = 0